module.exports = __webpack_public_path__ + "static/media/countdownL.1f612adc.png";